import useQueryState from "Components/Hooks/UseQueryState";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import { defaultFilter, FilterType } from "../Filters";
import { getPaymentsAgencyCount } from "common/services/payments.service";
import Skeleton from "react-loading-skeleton";
import * as moment from "moment";
import { Link } from "react-router-dom";
import AgencyModal from "pages/Agencies/AgencyModal";

const TotalPartners = () => {
  const [filter] = useQueryState<FilterType>("filter", defaultFilter);

  const [totalPartners, setTotalPartners] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getPaymentsAgencyCount({
          mdaId: filter?.mda?.value || undefined,
          regionId: filter?.region?.value || undefined,
          positionTypeId: filter?.positionType?.value || undefined,
          agencyId: filter?.agency?.value || undefined,
          paymentCategoryId: filter?.paymentCategory?.value || undefined,
          thematicAreaId: filter?.thematicArea?.value || undefined,
          sectorId: filter?.sector?.value || undefined,
          startDate: filter?.dateRange?.fromDate
            ? moment(filter.dateRange.fromDate)
                .toDate()
                .toLocaleDateString("en-CA")
            : undefined,
          endDate: filter?.dateRange?.toDate
            ? moment(filter.dateRange.toDate)
                .toDate()
                .toLocaleDateString("en-CA")
            : undefined,
        });

        setTotalPartners(response?.agencyCount);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    filter?.agency?.value,
    filter?.dateRange?.fromDate,
    filter?.dateRange?.toDate,
    filter.mda,
    filter?.positionType?.value,
    filter?.paymentCategory?.value,
    filter?.region?.value,
    filter?.sector?.value,
    filter?.thematicArea?.value,
  ]);

  const toggleModal = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
    }
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <Link to={"#"} onClick={toggleModal}>
        <Card>
          <CardBody>
            <div className="d-flex align-items-center">
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-light text-primary rounded-circle fs-3 material-shadow">
                  <i className={"align-middle ri-earth-fill"}></i>
                </span>
              </div>
              <div className="flex-grow-1 ms-3">
                <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                  Total Partners
                </p>
                <h4 className=" mb-0">
                  {loading ? (
                    <Skeleton width={120} height={24} />
                  ) : (
                    <CountUp
                      start={0}
                      end={totalPartners}
                      decimals={0}
                      separator={","}
                      prefix={""}
                      duration={3}
                    />
                  )}
                </h4>
              </div>
            </div>
          </CardBody>
        </Card>
      </Link>
      <AgencyModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title="Total Partners"
        filter={filter}
      />
    </>
  );
};

export default TotalPartners;
